import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./QualificationSetup.css";
import SearchView from "../../widgets/SearchView";
import QualificationSetupSearchForm from './QualificationSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import withMenuPermission from "../../widgets/withMenuPermission";

const utils = new ViewUtils();
const headCells = [
    { id: 'SAQAQualificationID', numeric: false, disablePadding: true, label: 'Qualification ID' },
    { id: 'SAQAQualificationTitle', numeric: false, disablePadding: true, label: 'Qualification Title' }
];

class ProviderQualificationSearchModule extends Component {

    constructor(props) {
        super(props)

        let model = { SAQAQualificationID: "", SAQAQualificationTitle: "", id: this.props.programmeId };

        this.searchParameters =
            [
            { Name: "id", Value: this.props.programmeId },
            { Name: "SAQAQualificationID", Value: "" },
            { Name: "SAQAQualificationTitle", Value: "" },]
            

        this.state = {
            model: model,
            keyUpSwitch: false,
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: "", tooltip: "Remove Qualification", icon: "DeleteIcon", disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        };
    }

    onkeyup(e) {
         if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
         }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={utils.isNull(this.props.showTitle) || this.props.showTitle === true ? 'Qualifications' : null}>
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/Qualificationsetup/getsearch"}
                    entityViewPath='/Qualificationsetup'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp={"SAQAQualificationID"} SecondDescriptionProp={"SAQAQualificationTitle"} mode={this.props.mode}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    keyUpSwitch={this.state.keyUpSwitch}
                    deleteUrl={"api/sims/QualificationSetup/RemoveQualification"} useDeletePost={true}
                    promptTitle={"Remove Qualification"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the qualification is a permanent action and the qualification will not be available going forward. Are you sure you want to remove this qualification?"}
            >
                    <QualificationSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(ProviderQualificationSearchModule));

